module.exports = __webpack_public_path__ + "static/img/main_list_icon.717dfa56.png";